import { env } from "@/env";
import { CACHE_TAG_REGISTRY_BASE } from "@mw/shared/cacheTagRegistry";

export type { CacheTagMeta, CacheStore, KnownCacheTag } from "@mw/shared/cacheTagRegistry";
export { KNOWN_CACHE_TAGS } from "@mw/shared/cacheTagRegistry";

import type { KnownCacheTag } from "@mw/shared/cacheTagRegistry";

// Per-tag revalidate TTL (seconds). Optional — tags without an entry fall
// back to `defaultRevalidate` from the shared registry.
const REVALIDATE_OVERRIDES: Partial<Record<KnownCacheTag, number>> = {
  "xi-assets-cache": env.NEXT_PUBLIC_XI_ASSETS_CACHE_PERIOD,
  "xi-shared-sounds": env.NEXT_PUBLIC_XI_ASSETS_CACHE_PERIOD,
  "xi-shared-generations": env.NEXT_PUBLIC_XI_ASSETS_CACHE_PERIOD,
  "xi-music": env.NEXT_PUBLIC_XI_ASSETS_CACHE_PERIOD,
  "xi-iconic-voices": env.NEXT_PUBLIC_XI_ASSETS_CACHE_PERIOD,
  "ashby-jobs": env.NEXT_PUBLIC_ASHBY_CACHE_PERIOD,
  "music-song": env.NEXT_PUBLIC_CACHE_PERIOD,
  "soundboard-sounds": env.NEXT_PUBLIC_CACHE_PERIOD,
  "find-slug": env.NEXT_PUBLIC_CACHE_PERIOD,
  "posthog-feature-flags": env.NEXT_PUBLIC_CACHE_PERIOD,
  "markdown-cache": env.NEXT_PUBLIC_PAYLOAD_CACHE_PERIOD,
};

export const CACHE_TAG_REGISTRY = CACHE_TAG_REGISTRY_BASE.map(e => ({
  ...e,
  revalidate: REVALIDATE_OVERRIDES[e.tag as KnownCacheTag] ?? e.defaultRevalidate,
}));

export const CACHE_TAG_REVALIDATE = Object.fromEntries(CACHE_TAG_REGISTRY.map(e => [e.tag, e.revalidate])) as Record<
  KnownCacheTag,
  number
>;
